module.exports = __webpack_public_path__ + "img/file.ec457f38.svg";